import React     from "react";
import { View }  from "react-native";
import palette   from "../../styles/palette";

export default function HorizontalRule() {
  return (
    <View
      style={{
        height: 1,
        backgroundColor: palette.light_grey,
        marginVertical: 8,
      }}
    />
  );
}
